import { render, staticRenderFns } from "./OrgDetailsManagement.vue?vue&type=template&id=49b64df6&scoped=true&"
import script from "./OrgDetailsManagement.vue?vue&type=script&lang=js&"
export * from "./OrgDetailsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b64df6",
  null
  
)

export default component.exports